/* eslint-disable no-console */
// Bildirim zincirinin (socket -> store -> toast) iz kaydı. Konsola sadece
// localStorage.notificationDebug = "1" iken yazar; canlıda sessizdir.
// Amaç: "socket'e veri geldi ama toast açılmadı" şikayetinde mesajın hangi
// adımda kaybolduğunu tek bakışta görmek.
//
// Her adım ayrıca clientLog'un bellek içi izine düşer; sunucuya tek başına
// gitmez, sadece bir uyarı/hata kaydına "trail" olarak eklenir.
import clientLog from "./clientLog";

const KEY = "notificationDebug";

function enabled() {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch (e) {
    return false;
  }
}

export default function debug(stage, payload) {
  clientLog.trace(stage, payload);
  if (!enabled()) return;
  const time = new Date().toTimeString().slice(0, 8);
  if (payload === undefined) {
    console.log("[bildirim " + time + "] " + stage);
  } else {
    console.log("[bildirim " + time + "] " + stage, payload);
  }
}
